import { LibService } from './libService';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { UserSessionService } from './user-session.service';
import { GuardService } from './guard.service';
import { AuthService } from '../auth/auth.service'

@Injectable({
  providedIn: 'root'
})
export class ActionSettingService extends BaseService {

  actionVisibilities: any = []

  constructor(
    public LibService: LibService,
    public AuthService: AuthService,
    public userSessionService: UserSessionService,
    public guardService: GuardService
  ) {
    super(LibService, AuthService)
    this.baseApi = environment.rootApiFoundation
    this.model = 'actionSettings'
  }

  checkPermissions(actionKey: any): boolean {
    this.actionVisibilities = this.userSessionService.getActionCodes()
    //console.log(this.actionVisibilities)
    return this.actionVisibilities.includes(actionKey)
  }

  createSettings(attributes: any): Observable<any> {
    return this.libService.postDataWithAccessToken<any>(this.tokenId, attributes, this.baseApi, `${this.model}/createSettings`);
  }

  setActionProfile(attributes: any): Observable<any> {
    return this.libService.postDataWithAccessToken<any>(this.tokenId, attributes, this.baseApi, `${this.model}/setActionProfile`);
  }

}